import React from 'react'
import styled, { css } from 'styled-components'
import useShop from '../context/AppContext'
import { Link } from 'react-router-dom'
import { SneakerCard } from '../components'
import { IconPlus } from '../assets/icons'
import { motion } from 'framer-motion'

const SectionWrapper = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  min-height: calc(100dvh - 100px);
  padding: 100px 0 200px;
  @media screen and (max-width: 1023px) {
    padding: 100px 0 150px;
  }
  @media screen and (max-width: 800px) {
    padding: 60px 0 130px;
  }
`
const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 86%;
  max-width: var(--max-width);
  margin: 0 auto;
  @media screen and (max-width: 800px) {
    flex-direction: column;
    width: calc(100% - 50px);
    margin: 0 25px;
  }
`
const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: calc(100% - 420px);
  padding-right: 80px;
  @media screen and (max-width: 1023px) {
    width: calc(100% - 320px);
    padding-right: 40px;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
    padding-right: 0;
  }
  h1 {
    line-height: 1.25;
    margin-bottom: 15px;
  }
  h3 {
    font-size: var(--fz-lg);
    color: var(--text);
    line-height: 1.5;
    font-weight: 400;
    margin-bottom: 30px;
  }
`
const RightColumn = styled.div`
  display: block;
  position: relative;
  width: 420px;
  height: 380px;
  .card-plus-1 {
    display: block;
    position: absolute;
    width: 28px;
    height: 28px;
    top: 480px;
    left: 110px;
  }
  .card-plus-2 {
    display: block;
    position: absolute;
    width: 28px;
    height: 28px;
    top: 330px;
    left: -90px;
  }
  .card-plus-3 {
    display: block;
    position: absolute;
    width: 28px;
    height: 28px;
    top: -80px;
    right: -50px;
  }
  @media screen and (max-width: 1023px) {
    width: 320px;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
    height: 0px;
    .card-plus-1 {
      top: 60px;
      left: 80px;
    }
    .card-plus-2 {
      display: none;
    }
    .card-plus-3 {
      top: 20px;
      right: 100px;
    }
  }
`
const ContainerBackground = styled.div`
  position: absolute;
  width: 420px;
  height: 380px;
  border-radius: 10px;
  background-color: var(--black-medium);
  @media screen and (max-width: 1023px) {
    width: 320px;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
    height: 0px;
    border-radius: 0px;
    background-color: transparent;
  }
`

const HomeHero = () => {
  const { preloaderExecuted, navigationExecuted } = useShop()

  const title = <h1>Your expert for Shopify development and web projects.</h1>
  const subtitle = <h3>Do you need an experienced and reliable Shopify developer or web specialist? Then I am your perfect choice for all your Shopify and web projects.</h3>
  const more = 'Check out my services'

  const handleLinkClick = () => {
    window.dataLayer.push({ event: 'btn_check_my_services' })
  }

  return (
    <SectionWrapper>
      <SectionContainer>
        {preloaderExecuted && navigationExecuted ? (
          <LeftColumn>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 0.1, duration: 0.3 }} className="start-opacity">
              {title}
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 0.2, duration: 0.3 }} className="start-opacity">
              {subtitle}
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 0.3, duration: 0.3 }} className="start-opacity">
              <Link onClick={handleLinkClick} to="/shopify-services" className="button">
                {more}
              </Link>
            </motion.div>
          </LeftColumn>
        ) : (
          <LeftColumn>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1, duration: 0.3 }} className="start-opacity">
              {title}
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1.1, duration: 0.3 }} className="start-opacity">
              {subtitle}
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1.2, duration: 0.3 }} className="start-opacity">
              <Link onClick={handleLinkClick} to="/shopify-services" className="button">
                {more}
              </Link>
            </motion.div>
          </LeftColumn>
        )}
        {preloaderExecuted && navigationExecuted ? (
          <RightColumn>
            <motion.div animate={{ opacity: [0, 1] }} transition={{ delay: 0.3, duration: 0.3 }} className="start-opacity">
              <ContainerBackground />
            </motion.div>
            <motion.div animate={{ scale: [1.05, 1], opacity: [0, 1] }} transition={{ delay: 0.5, duration: 0.5 }} className="start-opacity">
              <SneakerCard />
            </motion.div>
            <motion.div animate={{ scale: [0.25, 1], opacity: [0, 1] }} transition={{ delay: 0.7, duration: 0.3 }} className="card-plus-1 start-opacity">
              <IconPlus />
            </motion.div>
            <motion.div animate={{ scale: [0.25, 1], opacity: [0, 1] }} transition={{ delay: 0.8, duration: 0.3 }} className="card-plus-2 start-opacity">
              <IconPlus />
            </motion.div>
            <motion.div animate={{ scale: [0.25, 1], opacity: [0, 1] }} transition={{ delay: 0.9, duration: 0.3 }} className="card-plus-3 start-opacity">
              <IconPlus />
            </motion.div>
          </RightColumn>
        ) : (
          <RightColumn>
            <motion.div animate={{ opacity: [0, 1] }} transition={{ delay: 1.1, duration: 0.5 }} className="start-opacity">
              <ContainerBackground />
            </motion.div>
            <motion.div animate={{ scale: [1.05, 1], opacity: [0, 1] }} transition={{ delay: 1.3, duration: 0.5 }} className="start-opacity">
              <SneakerCard />
            </motion.div>
            <motion.div animate={{ scale: [0.25, 1], opacity: [0, 1] }} transition={{ delay: 1.5, duration: 0.3 }} className="card-plus-1 start-opacity">
              <IconPlus />
            </motion.div>
            <motion.div animate={{ scale: [0.25, 1], opacity: [0, 1] }} transition={{ delay: 1.6, duration: 0.3 }} className="card-plus-2 start-opacity">
              <IconPlus />
            </motion.div>
            <motion.div animate={{ scale: [0.25, 1], opacity: [0, 1] }} transition={{ delay: 1.7, duration: 0.3 }} className="card-plus-3 start-opacity">
              <IconPlus />
            </motion.div>
          </RightColumn>
        )}
      </SectionContainer>
    </SectionWrapper>
  )
}

export default HomeHero
